import React from "react";
import PropTypes from "prop-types";
import DateTd from "../../table-componets/DateTd.js";
import LinkTd from "../../table-componets/LinkTd.js";
import CertificationIndexRow from "./CertificationIndexRow.js";

const SaiCertificationsIndex = ({
  certifications,
  sortData,
  handlerDelete,
  openEditModal,
  programDirectors,
  instructorTrainers,
  trainingCenters,
  latestCertificationStepResult,
  updateCertificationStepResult,
  isSaiAdmin
}) => (
  <table className="table table-clean table-white">
    <thead>
      <tr>
        <th>
          <a
            onClick={(e) => { e.preventDefault(); that.sortData("users-last_name"); }}
            className="styled-link pointer-hand"
            role="button"
            aria-label="Sort by Name"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                that.sortData("users-last_name");
              }
            }}
          >
            Name
          </a>
        </th>
        <th>Certification</th>
        <th>
          <span className="pull-right">Completed On</span>
        </th>
        
        <th>
          <span className="pull-right">
            <a
              onClick={(e) => { e.preventDefault(); that.sortData("expiration_date"); }}
              className="styled-link pointer-hand"
              role="button"
              aria-label="Sort by Expiration Date"
              tabIndex="0"
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  that.sortData("expiration_date");
                }
              }}
            >
              Expiration Date
            </a>
          </span>
        </th>
        <th>Program Director</th>
        <th>Instructor Trainer</th>
        <th>Training Center</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {certifications.map((certification, index) => (
        <CertificationIndexRow
          key={index}
          certification={certification}
          handlerDelete={handlerDelete}
          index={index}
          programDirectors={programDirectors}
          instructorTrainers={instructorTrainers}
          trainingCenters={trainingCenters}
          updateCertificationStepResult={updateCertificationStepResult}
          isSaiAdmin={isSaiAdmin}
        />
      ))}
    </tbody>
  </table>
);

SaiCertificationsIndex.propType = {
  certifications: PropTypes.object,
  handlerDelete: PropTypes.func,
  openEditModal: PropTypes.func,
  sortData: PropTypes.func,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  updateCertificationStepResult: PropTypes.func,
  isSaiAdmin: PropTypes.bool
};

export default SaiCertificationsIndex;
